import moment from "moment";
import {Controller, useForm} from "react-hook-form";
import React, {useEffect, useMemo} from "react";
import {Box, Button, Card, CardContent, CircularProgress, Grid, TextField} from "@mui/material";
import {DateField} from "~/apps/core/ui/DateField";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {useCurrentUser} from "~/auth/hooks";
import {LoadingBox} from "~/apps/core/ui/LoadingBox";

export type FormValues = {
    dates: [Date, Date]
    email: string

}

export type ReconciliationDetailsFormProps = {
    onSubmit?: (data: FormValues) => Promise<any> | void
    loading?: boolean
}

export const ReconciliationDetailsForm = (props: ReconciliationDetailsFormProps) => {
    const {onSubmit, loading} = props;

    const [user, isUserLoading] = useCurrentUser();

    const defaultValues = useMemo(() => ({
        dates: [moment().startOf('months').toDate(), moment().toDate()],
        email: user?.email ? user.email.split(";")[0].trim() : null
    }), []);

    const {handleSubmit, getValues, setValue, formState, trigger, control} = useForm<FormValues>({
        defaultValues: defaultValues,
        mode: "onChange",
    });


    // initial validation
    useEffect(() => {
        trigger();
    }, []);

    useEffect(() => {
        if (user?.email && !getValues("email")) {
            setValue("email", user.email.split(";")[0].trim());
        }
    }, [user]);

    if (isUserLoading) {
        return (
            <Box pt={2}>
                <LoadingBox loading={isUserLoading}/>
            </Box>
        );
    } else {
        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} direction="column">
                            <Grid item>
                                <Controller
                                    name="dates"
                                    control={control}
                                    rules={{required: true}}
                                    render={({onChange, value}) => (
                                        <DateField
                                            label="Период"
                                            fullWidth={true}
                                            value={value}
                                            onChange={onChange}
                                            range
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item>
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{required: true}}
                                    render={({onChange, value}) => (
                                        <TextField
                                            label="Электронная почта"
                                            placeholder="ivanov@mail.ru"
                                            fullWidth
                                            inputProps={{maxLength: 128}}
                                            value={value}
                                            onChange={onChange}
                                            type="email"
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <FloatingActions>
                    <Button
                        type="submit"
                        color="primary"
                        fullWidth={true}
                        disabled={!formState.isValid || formState.isSubmitting}
                    >
                        {loading ? <CircularProgress size={24} color="secondary" /> : "Запросить детализацию (PDF)"}
                    </Button>
                </FloatingActions>
            </form>
        )
    }
}
